import { TinabaAPI } from './TinabaAPI'

export default class {
  $api!: TinabaAPI;
  constructor (api: TinabaAPI) {
    this.$api = api;
  }

  getPublicDetails (merchantId: number|string) {
    return this.$api.request({
      url: `api/usr/v2/businesses/${merchantId}/public-details`,
      method: 'GET'
    })
  }

  getShopPublicDetails (merchantId: number|string, shopId: number | string) {
    return this.$api.request({
      url: `api/usr/v2/businesses/${merchantId}/shops/${shopId}/public-details`,
      method: 'GET'
    })
  }

  listPublicVasses (merchantId: number|string, params = { page: 0, size: 999 }) {
    return this.$api.request({
      url: `api/ecm/v2/businesses/${merchantId}/public/vasses`,
      method: 'GET',
      params
    })
  }

  getMenu (merchantId: number|string, shopId: number|string, menuId: number|string) {
    return this.$api.request({
      url: `api/ecm/v2/businesses/${merchantId}/${shopId}/public/menus/${menuId}`,
      method: 'GET'
    })
  }

  getAvailableSlots (merchantId: number|string, shopId: number|string, vasId: number|string) {
    return this.$api.request({
      url: `api/ecm/v2/businesses/${merchantId}/${shopId}/public/vasses/${vasId}/slots`,
      method: 'GET'
    })
  }

  getProduct (merchantId: number|string, shopId: number|string, productId: number|string) {
    return this.$api.request({
      url: `api/ecm/v2/businesses/${merchantId}/${shopId}/public/products/${productId}`,
      method: 'GET'
    })
  }

  getDeliveryArea (merchantId: number|string, shopId: number|string, productId: number|string) {
    return this.$api.request({
      url: `api/ecm/v2/businesses/${merchantId}/${shopId}/public/vasses/${productId}/delivery-area`,
      method: 'GET'
    })
  }

  validateDeliveryAddress (merchantId: number|string, shopId: number|string, vasId: number|string, data: {longitude: string, latitude: string}) {
    return this.$api.request({
      url: `api/ecm/v2/businesses/${merchantId}/${shopId}/public/vasses/${vasId}/delivery-area`,
      method: 'POST',
      data
    })
  }

  getCart (vasId: number|string, cartId: number|string) {
    return this.$api.request({
      url: `api/ecm/v2/public/vasses/${vasId}/carts/${cartId}`,
      method: 'GET',
      headers: {
        'sessionId': TinabaAPI.sessionId,
      }
    })
  }

  createCart (vasId: number|string, data: any) {
    return this.$api.request({
      url: `api/ecm/v2/public/vasses/${vasId}/carts`,
      method: 'POST',
      data,
      headers: {
        'sessionId': TinabaAPI.sessionId,
      }
    })
  }

  cartAddUpdateItem (vasId: number|string, cartId: number|string, productId: number|string, quantity: any, isAdding = true) {
    const value = isAdding ? { "id": productId, "requestedQuantity": quantity } : quantity
    return this.$api.request({
      url: `api/ecm/v2/public/vasses/${vasId}/carts/${cartId}${!isAdding ? `/products/${productId}` : ''}`,
      method: 'PATCH',
      data: [{
        "op": isAdding ? "add" : 'replace',
        "path": isAdding ? "/products/-" : '/requestedQuantity',
        value
      }],
      headers: {
        'sessionId': TinabaAPI.sessionId
      }
    })
  }

  cartRemoveItem (vasId: number|string, cartId: number|string, productId: number|string, quantity: any) {
    return this.$api.request({
      url: `api/ecm/v2/public/vasses/${vasId}/carts/${cartId}`,
      method: 'PATCH',
      data: [{
        "op": 'remove',
        "path": "/products/-",
        "value": {
          "id": productId,
          "requestedQuantity": quantity
        }
      }],
      headers: {
        'sessionId': TinabaAPI.sessionId
      }
    })
  }

  cartUpdateAddress (vasId: number|string, cartId: number|string, address: MerchantAddress, type = 'billing', email: string = '', fiscalCode: string ='', pickupPoint: string = '', message: string = '') {
    const data : any = [
      {
        "op": "add",
        "path": type === 'billing' ? '/billingAddress' : '/shippingAddress',
        value: address
      }
    ]

    if (email && email.length) {
      data.push({
        "op": "replace",
        "path": '/customer/email',
        value: email
      })
    }

    if (fiscalCode && fiscalCode.length) {
      data.push({
        "op": "replace",
        "path": '/customer/fiscalCode',
        value: fiscalCode
      })
    }

    if (pickupPoint && pickupPoint.length) {
      data.push({
        "op": "replace",
        "path": '/customer/pickupPoint',
        value: pickupPoint
      })
    }
    
    if (message && message.length) {
      data.push({
        "op": "replace",
        "path": '/customer/message',
        value: message
      })
    }    

    return this.$api.request({
      url: `api/ecm/v2/public/vasses/${vasId}/carts/${cartId}`,
      method: 'PATCH',
      data,
      headers: {
        'sessionId': TinabaAPI.sessionId
      }
    })
  }

  cartUpdateCustomerEmail (vasId: number|string, cartId: number|string, email: string) {
    return this.$api.request({
      url: `api/ecm/v2/public/vasses/${vasId}/carts/${cartId}`,
      method: 'PATCH',
      data: [{
        "op": "replace",
        "path": '/customer/email',
        value: {
          email
        }
      }],
      headers: {
        'sessionId': TinabaAPI.sessionId
      }
    })
  }

  initCheckout (vasId: number, cartId: string, redirectUrl: string, slot?: CartTimeSlot, shippingAddressId?: number) {
    const payload : InitCheckoutPayload = {
      vasId,
      cartId,
      redirectUrl
    }

    if (shippingAddressId) {
      payload['shippingAddressId'] = shippingAddressId;
    }

    if (slot) {
      payload['slot'] = slot;
    }

    return this.$api.request({
      url: `api/usr/v2/vas-order/initCheckout`,
      method: 'POST',
      data: payload,
      headers: {
        'sessionId': TinabaAPI.sessionId
      }
    })
  }

  getVasPaymentMethods (merchantId: number|string, shopId: number|string) {
    return this.$api.request({
      url: `api/usr/v2/businesses/${merchantId}/shops/${shopId}/flow/VAS_ORDER/payment-methods`,
      method: 'GET',
      headers: {
        'sessionId': TinabaAPI.sessionId
      }
    })
  }


  getVasOrder (id: number) {
    return this.$api.request({
      url: `api/usr/v2/vas-order/pending/${id}`,
      method: 'GET',
      headers: {
        'sessionId': TinabaAPI.sessionId
      }
    })
  }

  createAlipayCheckout (requestPaymentId: number) {
    return this.$api.request({
      url: `api/bus/v2/alipay-connect/merchant-checkout/start`,
      method: 'POST',
      data: {
        requestPaymentId
      }
    })
  }

  createPaypalCheckout (requestPaymentId: number, paymentMethod: string) {
    return this.$api.request({
      url: `api/bus/v2/paypal/checkout/start`,
      method: 'POST',
      data: {
        requestPaymentId,
        paymentMethod
      }
    })
  }

  getVasPickupPointsPublic(merchantId: number|string, shopId: number|string, vasId: number|string) {
    return this.$api.request({
      url: `api/ecm/v2/businesses/${merchantId}/${shopId}/public/vasses/${vasId}/pickup-points`,
      method: 'GET'
    })
  }

  getProductCategory(id: string) {
    return this.$api.request({
      url: `api/ecm/v2/public/products/categories/${id}`,
      method: 'GET'
    })
  }  

  confirmPaypalCheckout (payload = {}) {
    return this.$api.request({
      url: `api/bus/v2/paypal/payments/business/complete`,
      method: 'POST',
      data: payload
    })
  }

  fetchPaypalData (businessId: number) {
    return this.$api.request({
      url: `api/bus/v2/paypal/businesses/${businessId}/payment-button/data`,
      method: 'GET'
    })
  }

  fetchErrorMessages (locale = 'it') {
    return this.$api.request({
      url: `api/v2/errors/messages?locale=${locale}`,
      method: 'GET'
    })
  }
}
